export default __webpack_public_path__ + "static/featureImage8-a3ad35039d5959c8e4b007be05f77ab0.webp";